"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createRichTextDocument(paragraphs, stringify) {
    if (paragraphs === void 0) { paragraphs = ['']; }
    if (stringify === void 0) { stringify = false; }
    var document = paragraphs.map(function (text) { return ({
        children: [{ text: text }],
        type: 'paragraph',
    }); });
    if (stringify) {
        return JSON.stringify(document);
    }
    return document;
}
exports.default = createRichTextDocument;
//# sourceMappingURL=createRichTextDocument.js.map